import { isFuture, isPast, parseISO } from 'date-fns';

export const isOngoing = (startTime: string, endTime: string): boolean =>
  isPast(parseISO(startTime)) && isFuture(parseISO(endTime));
